import { render, staticRenderFns } from "./add-edit-entity.vue?vue&type=template&id=3d13a5e2&scoped=true"
import script from "./add-edit-entity.vue?vue&type=script&lang=js"
export * from "./add-edit-entity.vue?vue&type=script&lang=js"
import style0 from "./add-edit-entity.vue?vue&type=style&index=0&id=3d13a5e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d13a5e2",
  null
  
)

export default component.exports